import { Component, OnInit } from '@angular/core';
import { IDashboard, IDashboardFilter } from 'src/app/pages/dashboard/models/dashboard';
import { SessionService } from 'src/app/shared/services/session.service';
import { DashboardsService } from '../../services/dashboards.service';

@Component({
  selector: 'app-my-dashboard',
  templateUrl: './my-dashboard.component.html',
  styleUrls: ['./my-dashboard.component.scss']
})
export class MyDashboardComponent implements OnInit {
  dadosPaginacao = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  dashboards: IDashboard[] = [];

  private companyId?: string;

  constructor(private readonly dashboardsService: DashboardsService, private readonly sessionService: SessionService) {}

  ngOnInit(): void {
    this.companyId = this.sessionService.getSession().companyId;
    this.carregarDashboards();
  }

  public carregarDashboards(): void {
    const filtros: IDashboardFilter = {
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (this.companyId) {
      filtros.companyId = this.companyId;
    }

    this.dashboardsService.listarMyDashboardsByFilter(filtros).subscribe((res) => {
      this.dashboards = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarDashboards();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;

    this.carregarDashboards();
  }
}
